import React from 'react'
import styles from './index.module.less'

export default function Plate(props: { title: string; explain: string }) {
  const { title, explain } = props
  return (
    <ul className={styles.plate}>
      <li className={styles.title}>{title}</li>
      <li className={styles.explain}>{explain}</li>
    </ul>
  )
}
